let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jCH24")).then(() => parcelRequire('dm7sF'));